import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=28fe6c91&scoped=true"
import script from "./withdraw.vue?vue&type=script&lang=ts"
export * from "./withdraw.vue?vue&type=script&lang=ts"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=28fe6c91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe6c91",
  null
  
)

export default component.exports